import Phaser from 'phaser';
import { PHASER_CONFIG } from './config/gameConfig';
import { BootScene } from './scenes/BootScene';
import { TitleScene } from './scenes/TitleScene';
import { GameScene } from './scenes/GameScene';
import { ResultScene } from './scenes/ResultScene';
import { EncyclopediaScene } from './scenes/EncyclopediaScene';

// シーンを追加
const config: Phaser.Types.Core.GameConfig = {
  ...PHASER_CONFIG,
  scene: [BootScene, TitleScene, GameScene, ResultScene, EncyclopediaScene],
};

// ゲームインスタンスの作成
const game = new Phaser.Game(config);

// レスポンシブ対応: リサイズ処理関数
const handleResize = () => {
  if (game && game.scale) {
    game.scale.refresh();
  }
};

// ウィンドウリサイズ時の処理
window.addEventListener('resize', handleResize);

// モバイルデバイスの向き変更時の処理
window.addEventListener('orientationchange', () => {
  setTimeout(handleResize, 100);
});

// ビューポートの変更を検知（モバイルのアドレスバー表示/非表示など）
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', handleResize);
}

// デバッグ用: ゲームインスタンスをグローバルに公開
if (import.meta.env.DEV) {
  (window as unknown as { game: Phaser.Game }).game = game;
}
